module.exports = __webpack_public_path__ + "img/empty.3465968b.png";